import { Navigate } from "react-router-dom";
import usePermissions from "datasets/hooks/usePermissions";
import AddTable from "datasets/pages/tables/pages/AddTable";
import { ROUTE_404 } from "~/router/constants";

export const DatasetAddTable = () => {
  const canCreate = usePermissions("create:catalog-ingest");
  if (!canCreate) {
    return <Navigate to={ROUTE_404} replace />;
  }
  return <AddTable />;
};
